import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { AfterViewInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { environment } from '../../../../../../../../environments/environment';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { PersonGenderService } from '../../../../../../services/person-genders/person-gender.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { AuthenticationService } from '../../../../../../services/authentication/authentication.service';

import { Lightbox } from 'ngx-lightbox';
import { Observable } from 'rxjs/Observable';
import { JobTitleData } from '../../../../../../models/employee/add-employee-dto';
import { MY_FORMATS } from '../../../../../../const/date-format';
import { MedicalLetterTypeService } from '../../../../../../services/medical-letter-types/medical-letter-type.service';
import { PersonService } from '../../../../../../services/person/person.service';
import { MedicalLetterDto } from '../../../../../../models/medical-letter/medical-letter-dto';
import { MedicalLetterService } from '../../../../../../services/medical-letter/medical-letter-service';
import { RelationshipService } from '../../../../../../services/relationships/relationship.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { EmployeeService } from '../../../../../../services/employee/employee.service';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';

import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';

@Component({
    selector: 'fuse-add-medical-letter',
    templateUrl: './add-medical-letter.component.html',
    styleUrls: ['./add-medical-letter.component.scss'],
    providers: [
        {provide: MAT_DATE_LOCALE, useValue: 'es-Es'},
        {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    ],
    animations: fuseAnimations
})
export class AddMedicalLetterComponent implements OnInit, AfterViewInit, OnDestroy {

    @BlockUI('tracker-dialog') blockUI: NgBlockUI;

    formGroup;
    docNumberFormControl;
    lastNameFormControl;
    firstNameFormControl;
    birthdateFormControl;
    requestDateFormControl;
    genderFormControl;
    observationsFormControl;
    relationshipFormControl;
    shiftIdFormControl;
    typeEmployeeIdFormControl;

    public baseUri;

    minDate = new Date(1930, 0, 1);
    maxDate = new Date();
    public medicalLettersTypes: any[];
    public relationships: any[];
    public shifts: any[] = [];
    public employee: any;

    mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
    maskedInputControllerRequestDate;
    maskedInputControllerRelativeBirthdate;

    @ViewChild('requestDate', {read: ViewContainerRef}) public requestDate;
    @ViewChild('relativeBirthdate', {read: ViewContainerRef}) public relativeBirthdate;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<AddMedicalLetterComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        public personGenderService: PersonGenderService,
        private authenticationService: AuthenticationService,
        private _lightbox: Lightbox,
        private medicalLetterTypeService: MedicalLetterTypeService,
        private personService: PersonService,
        private medicalLetterService: MedicalLetterService,
        public relationshipService: RelationshipService,
        public shiftService: ShiftService,
        public employeeService: EmployeeService,
        public typeEmployeeService: TypeEmployeeService,
        private cdRef: ChangeDetectorRef
    ) {
        console.log('FuseAddMedicalLetterComponent > data', data);
        this.initializeFormControlValidators();
        this.baseUri = environment.baseUri + '/images/';
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);

        Observable.combineLatest(
            this.personGenderService.getAll(),
            this.medicalLetterTypeService.getAll(),
            this.relationshipService.getAll(),
            this.shiftService.getAll(),
            this.employeeService.getAll(),
            this.typeEmployeeService.getAll()
        ).subscribe(([personGenders, medicalLettersTypes, relationships, shifts, employees, typeEmployees]) => {
            this.employee = this.employeeService.employees.find(e => e.Id === this.data.employeeId);
            const employeeShifts = this.employee.JobTitles.map(j => j.ShiftId);
            if (this.employee) {
                shifts.forEach(e => {
                    if (employeeShifts.includes(e.Id)) {
                        this.shifts.push(e);
                    }
                });
            }

            this.blockUI.stop();
            this.medicalLettersTypes = medicalLettersTypes.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: this.data.medicalLetter.MedicalLetterTypes.find(t => t === e.Id), Disabled: this.data.mode === 'view'};
            });
            this.relationships = relationships;
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });

        if (this.data.mode === 'view') {
            this.disable();
        }
    }

    disable() {
        this.formGroup.get('docNumberFormControl').disable();
        this.formGroup.get('lastNameFormControl').disable();
        this.formGroup.get('firstNameFormControl').disable();
        this.formGroup.get('birthdateFormControl').disable();
        this.formGroup.get('requestDateFormControl').disable();
        this.formGroup.get('genderFormControl').disable();
        this.formGroup.get('observationsFormControl').disable();
        this.formGroup.get('relationshipFormControl').disable();
        this.formGroup.get('shiftIdFormControl').disable();
        this.formGroup.get('typeEmployeeIdFormControl').disable();
    }

    ngOnDestroy() {
        this.maskedInputControllerRequestDate.destroy();
        if (this.maskedInputControllerRelativeBirthdate) {
            this.maskedInputControllerRelativeBirthdate.destroy();
        }
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.maskedInputControllerRequestDate = textMask.maskInput({
                inputElement: this.requestDate.element.nativeElement,
                mask: this.mask
            });
        });
    }

    initializeFormControlValidators() {
        this.formGroup = this.fb.group({
            docNumberFormControl: ['', [Validators.required, Validators.maxLength(10)]],
            lastNameFormControl: ['', [Validators.required]],
            firstNameFormControl: ['', [Validators.required]],
            birthdateFormControl: ['', [Validators.required]],
            requestDateFormControl: ['', [Validators.required]],
            genderFormControl: ['', [Validators.required]],
            relationshipFormControl: ['', [Validators.required]],
            shiftIdFormControl: ['', [Validators.required]],
            typeEmployeeIdFormControl: ['', [Validators.required]],
            observationsFormControl: ['', []]
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        if (this.data.mode === 'new') {
            console.log('nuevo');
            this.addMedicalLetter();
        } else {
            console.log('editar');
            this.editMedicalLetter();
        }
    }

    addMedicalLetter() {
        this.blockUI.start(this.translationService.savingChanges);
        this.data.medicalLetter.MedicalLetterTypes = this.medicalLettersTypes.filter(t => t.Checked).map(t => t.Id);

        const medicalLetterDto = new MedicalLetterDto();
        medicalLetterDto.Id = -1;
        medicalLetterDto.EmployeeId = this.data.employeeId;
        medicalLetterDto.RequestDate = this.data.medicalLetter.RequestDate;
        medicalLetterDto.Observations = this.data.medicalLetter.Observations;
        medicalLetterDto.Relatives.FirstName = this.data.medicalLetter.Relatives.FirstName;
        medicalLetterDto.Relatives.LastName = this.data.medicalLetter.Relatives.LastName;
        medicalLetterDto.Relatives.Birthdate = this.data.medicalLetter.Relatives.Birthdate;
        medicalLetterDto.Relatives.PersonGenderId = this.data.medicalLetter.Relatives.PersonGenderId;
        medicalLetterDto.Relatives.RelationshipId = this.data.medicalLetter.Relatives.RelationshipId;
        medicalLetterDto.Relatives.DocumentNumber = this.data.medicalLetter.Relatives.DocumentNumber;
        medicalLetterDto.MedicalLetterTypes = this.data.medicalLetter.MedicalLetterTypes;
        medicalLetterDto.ShiftId = this.data.medicalLetter.ShiftId;
        medicalLetterDto.TypeEmployeeId = this.data.medicalLetter.TypeEmployeeId;

        this.data.medicalLetter.LastName = this.data.employeeName;//this.data.medicalLetter.Relatives.LastName;
        //this.data.medicalLetter.FirstName = "FIRSTNAME";//this.data.medicalLetter.Relatives.FirstName;

        this.medicalLetterService.addOrEdit(medicalLetterDto).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                this.data.medicalLetter.Id = response.Id;
                this.medicalLetterService.medicalLettersByEmployee.push(this.data.medicalLetter);
                this.medicalLetterService.medicalLettersByEmployeeObject[String(this.data.medicalLetter.Id)] = this.data.medicalLetter;
                this.translationService.translate('LABELS.CORRECTLY_ADDED', this.translationService.medicalLetter, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
                
                this.dialogRef.close(this.data.medicalLetter);
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    selectAllContent($event) {
        if ($event.target.value === 0) {
            $event.target.select();
        }
    }

    editMedicalLetter() {
        this.blockUI.start(this.translationService.savingChanges);
        this.data.medicalLetter.MedicalLetterTypes = this.medicalLettersTypes.filter(t => t.Checked).map(t => t.Id);

        const medicalLetterDto = new MedicalLetterDto();
        medicalLetterDto.Id = this.data.medicalLetter.Id;
        medicalLetterDto.EmployeeId = this.data.employeeId;
        medicalLetterDto.RequestDate = this.data.medicalLetter.RequestDate;
        medicalLetterDto.Observations = this.data.medicalLetter.Observations;
        medicalLetterDto.Relatives.FirstName = this.data.medicalLetter.Relatives.FirstName;
        medicalLetterDto.Relatives.LastName = this.data.medicalLetter.Relatives.LastName;
        medicalLetterDto.Relatives.Birthdate = this.data.medicalLetter.Relatives.Birthdate;
        medicalLetterDto.Relatives.PersonGenderId = this.data.medicalLetter.Relatives.PersonGenderId;
        medicalLetterDto.Relatives.RelationshipId = this.data.medicalLetter.Relatives.RelationshipId;
        medicalLetterDto.Relatives.DocumentNumber = this.data.medicalLetter.Relatives.DocumentNumber;
        medicalLetterDto.MedicalLetterTypes = this.data.medicalLetter.MedicalLetterTypes;
        medicalLetterDto.ShiftId = this.data.medicalLetter.ShiftId;
        medicalLetterDto.TypeEmployeeId = this.data.medicalLetter.TypeEmployeeId;

        this.medicalLetterService.addOrEdit(medicalLetterDto).subscribe(response => {
            this.blockUI.stop();
            if (response.ResultCode === 1) {
                const index = this.medicalLetterService.medicalLettersByEmployee.findIndex(st => st.Id === this.data.medicalLetter.Id);
                console.log('index>>>> find', index);
                this.medicalLetterService.medicalLettersByEmployee[index] = this.data.medicalLetter;
                this.medicalLetterService.medicalLettersByEmployeeObject[this.data.medicalLetter.Id] = this.data.medicalLetter;
                this.dialogRef.close(this.data.medicalLetter);
                this.translationService.translate('LABELS.CORRECTLY_MODIFIED', this.translationService.medicalLetter, (res) => {
                    this.sweetAlertService.success(this.translationService.success, res, null);
                });
                console.log('this.medicalLetterService.medicalLettersByEmployee', this.medicalLetterService.medicalLettersByEmployee);
            } else {
                this.translationService.translate('ERRORS.ERROR_REQUEST', response.resultMsg, (res: string) => {
                    this.sweetAlertService.error('Error', res, null);
                });
            }
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    getAge(birthdate: Date) {
        //   console.log("Edad>>>>>", birthdate);
        const momentNow = moment();
        const momentBirthdate = moment(birthdate);
        const diffDuration = moment.duration(momentNow.diff(momentBirthdate));
        let age = '';
        if (!!diffDuration.years() && diffDuration.years() > 0) {
            age += diffDuration.years().toString() + (diffDuration.years() === 1 ? ' año' : ' años');
        }
        if (!!diffDuration.months() && diffDuration.months() > 0) {
            // tslint:disable-next-line:max-line-length
            // age += age == '' ? diffDuration.months().toString() + (diffDuration.months() == 1 ? ' mes' : ' meses') : ', ' + (diffDuration.months().toString() + (diffDuration.months() == 1 ? ' mes' : ' meses'));
            if ((momentBirthdate.month() === momentNow.month()) && (momentNow.date() <= momentBirthdate.date())) {
                age = (diffDuration.years() + 1).toString() + ((diffDuration.years() + 1) === 1 ? ' año' : ' años');
            } else {
                // tslint:disable-next-line:max-line-length
                age += age === '' ? diffDuration.months().toString() + (diffDuration.months() === 1 ? ' mes' : ' meses') : ', ' + (diffDuration.months().toString() + (diffDuration.months() === 1 ? ' mes' : ' meses'));
            }
        }
        return age;
    }

    addJobTitle() {
        this.data.medicalLetter.Relatives.JobTitles.push(new JobTitleData());
    }

    onBlurDocumentNumber() {
        if (!this.data.medicalLetter.Relatives.DocumentNumber) {
            return;
        }
        this.blockUI.start('buscando');
        this.personService.getByDocumentNumber(this.data.medicalLetter.Relatives.DocumentNumber).subscribe(e => {
            console.log(e);
            if (e) {
                this.data.medicalLetter.Relatives.LastName = e.LastName;
                this.data.medicalLetter.Relatives.FirstName = e.FirstName;
                this.data.medicalLetter.Relatives.Birthdate = e.Birthdate;
                this.data.medicalLetter.Relatives.DocumentNumber = e.DocumentNumber;
                this.data.medicalLetter.Relatives.PersonGenderId = e.PersonGender.Id;
            }
            this.blockUI.stop();
        });
    }

    requiredMedicalLetterTypes() {
        if (!this.medicalLettersTypes) {
            return false;
        }
        return this.medicalLettersTypes.filter(e => e.Checked).length === 0;
    }

    relativesSelected() {
        if (!this.medicalLettersTypes) {
            return false;
        }
        const r = this.medicalLettersTypes.find(e => e.Checked && e.Id === 3);


        return r;
    }

    changedShift(element) {
        console.log('element', element);
        const found = this.employee.JobTitles.find(j => j.ShiftId === element);
        if (found) {
            this.data.medicalLetter.TypeEmployeeId = found.TypeEmployeeId;
        }
    }

    changeType($event, item) {
        if (item.Id === 3) {
            if ($event) {
                setTimeout(() => {
                    this.maskedInputControllerRelativeBirthdate = textMask.maskInput({
                        inputElement: this.relativeBirthdate.element.nativeElement,
                        mask: this.mask
                    });
                });
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/medical-letter/components/add-medical-letter/add-medical-letter.component.ts